import { Order, PaymentProvider } from "../pages/SalesPage/SalesPageInterface";

const COUNTRY_CURRENCY: Record<string, string> = {
  AR: "ARS",
  BO: "BOB",
  BR: "BRL",
  CA: "CAD",
  CL: "CLP",
  CO: "COP",
  EC: "USD",
  GT: "GTQ",
  MX: "MXN",
  PE: "PEN",
  PY: "PYG",
  US: "USD",
  UY: "UYU",
  VE: "VES",
};

const numberOrZero = (value: number | string | null | undefined) => Number(value ?? 0);

const localCurrencyForCountry = (countryCode?: string | null) =>
  countryCode ? COUNTRY_CURRENCY[countryCode.toUpperCase()] : undefined;

export const getOrderDisplayCurrencyCode = (order: Order): string => {
  const localCurrency = localCurrencyForCountry(order.country_code);

  return (
    order.display_currency_code ||
    order.shopify_original_currency ||
    (order.payment_provider === PaymentProvider.SHOPIFY ? localCurrency : undefined) ||
    order.currency_code ||
    localCurrency ||
    order.country_code ||
    "COP"
  );
};

export const getOrderDisplayTotalValue = (order: Order): number =>
  numberOrZero(order.display_total_value ?? order.total_value);

export const getOrderDisplayTotalPaid = (order: Order): number =>
  numberOrZero(order.display_total_value_paid ?? order.total_value_paid);

export const getOrderDisplayTotalWithDiscount = (order: Order): number =>
  numberOrZero(
    order.display_total_value_with_discount ??
      order.shopify_original_total ??
      order.total_value_with_discount
  );
